
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30225',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30225",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54473",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7988",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11441",
  "I18n": "static-7.1616",
  "quartz": "static-1-hqd-quartz-routing-v2.22",
  "quartz-config": "static-1-hqd-quartz-routing-v2.22",
  "quartz-core": "static-1-hqd-quartz-routing-v2.22",
  "react-dlb": "static-1.78",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.784",
  "enviro": "static-4.428",
  "feedback-shared-ui": "static-1.54460",
  "feedback-utils": "static-1.54464",
  "forms-embed-utils-lib": "static-1.4436",
  "forms-utils-lib": "static-1.12523",
  "foundations-assets": "static-1.4837",
  "foundations-components": "static-1.7874",
  "foundations-theming": "static-1.4392",
  "hub-http": "static-1.6196",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11748",
  "icons": "static-2.644",
  "immutable": "static-2.77",
  "quick-fetch": "static-1.3894",
  "raven": "static-3.5829",
  "react": "static-7.185",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16643",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5322",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.486",
  "tinymce-plugins": "static-1.57397",
  "transmute": "static-2.85",
  "ui-images": "static-2.1145",
  "UIComponents": "static-3.8387",
  "hs-promise-rejection-tracking": "static-1.5489",
  "PortalIdParser": "static-2.388",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9542",
  "styled-components": "static-2.88",
  "bend-plugin-trellis-migration": "static-1.3382",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1-hqd-quartz-routing-v2.22",
  "quartz-webpack": "static-1-hqd-quartz-routing-v2.22",
  "foundations-theming-specialty": "static-1.2108",
  "property-description-translator": "static-1.3820",
  "HeadJS": "static-2.749",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3099",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4301",
  "jasmine-runner": "static-1.6441",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "hubspotter-http": "static-1.4630",
  "mobile-manifest-mixins": "static-1.523",
  "module-federation": "static-1.22",
  "quartz-auth": "static-1-hqd-quartz-routing-v2.22",
  "quartz-head": "static-1-hqd-quartz-routing-v2.22",
  "quartz-i18n": "static-1-hqd-quartz-routing-v2.22",
  "quartz-routing": "static-1-hqd-quartz-routing-v2.22",
  "quartz-test": "static-1-hqd-quartz-routing-v2.22",
  "quartz-tracking": "static-1-hqd-quartz-routing-v2.22",
  "ui-fonts": "static-1.703",
  "usage-tracker-container": "static-1.7309",
  "usage-tracker-core": "static-1.7169",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7222",
  "reference-resolvers": "static-1.8143",
  "sanitize-text": "static-1.8117",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10344",
  "sanitize": "static-1.4450",
  "outpost": "static-1.4160",
  "rpc-client-utils": "static-1.4626",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4143",
  "floating-ui": "static-1.55",
  "hs-story-utils": "static-1.9402",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.14",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1775",
  "bend-plugin-foundations-theming": "static-1.2875",
  "foundations-theming-base": "static-1.3377",
  "stylex": "static-1.32",
  "hs-locale-management": "static-1.63",
  "csstype": "static-1.50",
  "web-vitals": "static-1.4",
  "ai-components-ui-library": "static-1.8861",
  "atom": "static-1.5046",
  "codemirror": "static-5.94",
  "content-assistance-lib": "static-1.7708",
  "ContentUtils": "static-1.68272",
  "data-token-picker": "static-1.16356",
  "file-manager-components": "static-1.23536",
  "FileManagerCore": "static-1.39035",
  "FileManagerLib": "static-1.39176",
  "frontend-preferences-client": "static-1.7903",
  "hub-http-contrib": "static-1.3015",
  "interframe": "static-3.4735",
  "layout-dnd-components": "static-1.12390",
  "layout-dnd-utils": "static-1.11365",
  "property-translator": "static-1.5375",
  "react-codemirror": "static-1.10599",
  "react-colorpicker": "static-2.10184",
  "reference-resolvers-lite": "static-1.8069",
  "rich-text-lib": "static-1.19778",
  "tinymce-data": "static-1.40368",
  "tinymce-themes": "static-1.56253",
  "ui-addon-emoji-picker": "static-1.9862",
  "ui-addon-sales-email": "static-1.5185",
  "ui-brand-identity-lib": "static-1.15142",
  "bender-build-tools": "static-1.3160",
  "hub-http-shared-msw-handlers": "static-1.9890",
  "hubspotter-http-shared-msw-handlers": "static-1.9888",
  "usage-tracker-session-replay": "static-1.5005",
  "react-immutable-proptypes": "static-2.8",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.36",
  "chirp-fetch": "static-1.1861",
  "chatspot-core": "static-1.21145",
  "copilot-toolkit": "static-1.11057",
  "customer-data-objects-ui-components": "static-1.12999",
  "data-fetching-client": "static-1.9646",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4739",
  "ui-addon-video-player": "static-1.8675",
  "ui-coaching-tips": "static-1.28465",
  "usage-tracker": "static-1.7319",
  "cms-field-types": "static-1.4786",
  "content-icons-ui": "static-1.2218",
  "integrations-lib": "static-1.16020",
  "customer-data-objects": "static-1.7637",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4624",
  "apollo-stack-hubspot": "static-3.85",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "immerable": "static-1.4128",
  "ui-addon-iframeable": "static-1.9031",
  "video-components-external": "static-1.11173",
  "video-data-lib": "static-1.34831",
  "audio-components": "static-1.5872",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29241",
  "FileManagerImages": "static-1.36687",
  "foundations-components-legacy": "static-1.899",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.524",
  "ui-universal-auth": "static-1.8944",
  "urlinator": "static-1.4509",
  "video-components": "static-1.13176",
  "video-embed": "static-1.35665",
  "ts-schema": "static-1.4057",
  "ContentData": "static-1.68347",
  "layout-data-lib": "static-1.9690",
  "react-dnd-compat": "static-1.4594",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1515",
  "external-options-client-types": "static-1.4136",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6856",
  "hs-promise-utils": "static-1.5569",
  "inbound-db-properties-service-client": "static-1.3822",
  "NamespacedHubStyle": "static-2.9039",
  "growth-onboarding-confetti": "static-1.3041",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11125",
  "amplitude-session-replay-browser": "static-1.59",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5537",
  "magpie-types": "static-1.4997",
  "simple-logging-lib": "static-1.3023",
  "avatar-components": "static-1.2472",
  "customer-data-ui-utilities": "static-1.9800",
  "growth-onboarding-feedback-components": "static-1.6556",
  "flux-actions": "static-1.331",
  "hubspot-apollo-client": "static-1.4851",
  "integrations-error-boundary-lib": "static-1.13435",
  "integrations-tracking-lib": "static-1.5573",
  "laboratory-lib": "static-3.7133",
  "native-integrations-shared-strings": "static-1.7757",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10129",
  "unified-auth": "static-1.458",
  "navigation-messaging": "static-1.7266",
  "content-media-composition-data-lib": "static-1.12160",
  "content-media-compositions": "static-2.16167",
  "idb-keyval": "static-1.43",
  "media-bridge-lib": "static-1.18874",
  "unified-auth-core-lib": "static-1.740",
  "social-insights-client-types": "static-1.22006",
  "advanced-menus-core": "static-1.15086",
  "advanced-menus-lib": "static-1.12031",
  "ExportDialog": "static-6.10366",
  "ui-memberships-settings-lib": "static-1.33963",
  "conditional-properties-service-client": "static-1.3775",
  "crm-pipelines-api-client-types": "static-1.4120",
  "framework-builder-read-service-client": "static-1.3987",
  "framework-data-schema-quick-fetch": "static-1.6761",
  "inbound-db-meta-service-client": "static-1.3568",
  "multi-currency-client-types": "static-1.3669",
  "persist-promise": "static-1.3672",
  "foundations-components-test-utils": "static-1.5357",
  "reactive-lib": "static-1.696",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.310",
  "universal-page-editor-lib": "static-1.2987",
  "google-sheets-integration-lib": "static-1.146",
  "microsoft-drive-integration-lib": "static-1.263",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3705",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15085",
  "simple-menus-lib": "static-1.16602",
  "crm-record-cards-service-types": "static-1.3586",
  "location-customization-utils-lib": "static-1.9161",
  "react-flip-move": "static-1.69"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30225",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54473",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7988",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11441",
  "I18n": "/I18n/static-7.1616",
  "quartz": "/quartz/static-1-hqd-quartz-routing-v2.22",
  "quartz-config": "/quartz-config/static-1-hqd-quartz-routing-v2.22",
  "quartz-core": "/quartz-core/static-1-hqd-quartz-routing-v2.22",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.784",
  "enviro": "/enviro/static-4.428",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54460",
  "feedback-utils": "/feedback-utils/static-1.54464",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4436",
  "forms-utils-lib": "/forms-utils-lib/static-1.12523",
  "foundations-assets": "/foundations-assets/static-1.4837",
  "foundations-components": "/foundations-components/static-1.7874",
  "foundations-theming": "/foundations-theming/static-1.4392",
  "hub-http": "/hub-http/static-1.6196",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11748",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.77",
  "quick-fetch": "/quick-fetch/static-1.3894",
  "raven": "/raven/static-3.5829",
  "react": "/react/static-7.185",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16643",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5322",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "tinymce-plugins": "/tinymce-plugins/static-1.57397",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1145",
  "UIComponents": "/UIComponents/static-3.8387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9542",
  "styled-components": "/styled-components/static-2.88",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3382",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1-hqd-quartz-routing-v2.22",
  "quartz-webpack": "/quartz-webpack/static-1-hqd-quartz-routing-v2.22",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2108",
  "property-description-translator": "/property-description-translator/static-1.3820",
  "HeadJS": "/HeadJS/static-2.749",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3099",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4301",
  "jasmine-runner": "/jasmine-runner/static-1.6441",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "hubspotter-http": "/hubspotter-http/static-1.4630",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.523",
  "module-federation": "/module-federation/static-1.22",
  "quartz-auth": "/quartz-auth/static-1-hqd-quartz-routing-v2.22",
  "quartz-head": "/quartz-head/static-1-hqd-quartz-routing-v2.22",
  "quartz-i18n": "/quartz-i18n/static-1-hqd-quartz-routing-v2.22",
  "quartz-routing": "/quartz-routing/static-1-hqd-quartz-routing-v2.22",
  "quartz-test": "/quartz-test/static-1-hqd-quartz-routing-v2.22",
  "quartz-tracking": "/quartz-tracking/static-1-hqd-quartz-routing-v2.22",
  "ui-fonts": "/ui-fonts/static-1.703",
  "usage-tracker-container": "/usage-tracker-container/static-1.7309",
  "usage-tracker-core": "/usage-tracker-core/static-1.7169",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7222",
  "reference-resolvers": "/reference-resolvers/static-1.8143",
  "sanitize-text": "/sanitize-text/static-1.8117",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10344",
  "sanitize": "/sanitize/static-1.4450",
  "outpost": "/outpost/static-1.4160",
  "rpc-client-utils": "/rpc-client-utils/static-1.4626",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4143",
  "floating-ui": "/floating-ui/static-1.55",
  "hs-story-utils": "/hs-story-utils/static-1.9402",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.14",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1775",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2875",
  "foundations-theming-base": "/foundations-theming-base/static-1.3377",
  "stylex": "/stylex/static-1.32",
  "hs-locale-management": "/hs-locale-management/static-1.63",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.4",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8861",
  "atom": "/atom/static-1.5046",
  "codemirror": "/codemirror/static-5.94",
  "content-assistance-lib": "/content-assistance-lib/static-1.7708",
  "ContentUtils": "/ContentUtils/static-1.68272",
  "data-token-picker": "/data-token-picker/static-1.16356",
  "file-manager-components": "/file-manager-components/static-1.23536",
  "FileManagerCore": "/FileManagerCore/static-1.39035",
  "FileManagerLib": "/FileManagerLib/static-1.39176",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7903",
  "hub-http-contrib": "/hub-http-contrib/static-1.3015",
  "interframe": "/interframe/static-3.4735",
  "layout-dnd-components": "/layout-dnd-components/static-1.12390",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11365",
  "property-translator": "/property-translator/static-1.5375",
  "react-codemirror": "/react-codemirror/static-1.10599",
  "react-colorpicker": "/react-colorpicker/static-2.10184",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8069",
  "rich-text-lib": "/rich-text-lib/static-1.19778",
  "tinymce-data": "/tinymce-data/static-1.40368",
  "tinymce-themes": "/tinymce-themes/static-1.56253",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9862",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5185",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15142",
  "bender-build-tools": "/bender-build-tools/static-1.3160",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9890",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9888",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5005",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.36",
  "chirp-fetch": "/chirp-fetch/static-1.1861",
  "chatspot-core": "/chatspot-core/static-1.21145",
  "copilot-toolkit": "/copilot-toolkit/static-1.11057",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12999",
  "data-fetching-client": "/data-fetching-client/static-1.9646",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4739",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8675",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28465",
  "usage-tracker": "/usage-tracker/static-1.7319",
  "cms-field-types": "/cms-field-types/static-1.4786",
  "content-icons-ui": "/content-icons-ui/static-1.2218",
  "integrations-lib": "/integrations-lib/static-1.16020",
  "customer-data-objects": "/customer-data-objects/static-1.7637",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4624",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4128",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9031",
  "video-components-external": "/video-components-external/static-1.11173",
  "video-data-lib": "/video-data-lib/static-1.34831",
  "audio-components": "/audio-components/static-1.5872",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29241",
  "FileManagerImages": "/FileManagerImages/static-1.36687",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.899",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.524",
  "ui-universal-auth": "/ui-universal-auth/static-1.8944",
  "urlinator": "/urlinator/static-1.4509",
  "video-components": "/video-components/static-1.13176",
  "video-embed": "/video-embed/static-1.35665",
  "ts-schema": "/ts-schema/static-1.4057",
  "ContentData": "/ContentData/static-1.68347",
  "layout-data-lib": "/layout-data-lib/static-1.9690",
  "react-dnd-compat": "/react-dnd-compat/static-1.4594",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1515",
  "external-options-client-types": "/external-options-client-types/static-1.4136",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6856",
  "hs-promise-utils": "/hs-promise-utils/static-1.5569",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3822",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9039",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3041",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11125",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5537",
  "magpie-types": "/magpie-types/static-1.4997",
  "simple-logging-lib": "/simple-logging-lib/static-1.3023",
  "avatar-components": "/avatar-components/static-1.2472",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9800",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6556",
  "flux-actions": "/flux-actions/static-1.331",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4851",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13435",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5573",
  "laboratory-lib": "/laboratory-lib/static-3.7133",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7757",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10129",
  "unified-auth": "/unified-auth/static-1.458",
  "navigation-messaging": "/navigation-messaging/static-1.7266",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12160",
  "content-media-compositions": "/content-media-compositions/static-2.16167",
  "idb-keyval": "/idb-keyval/static-1.43",
  "media-bridge-lib": "/media-bridge-lib/static-1.18874",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.740",
  "social-insights-client-types": "/social-insights-client-types/static-1.22006",
  "advanced-menus-core": "/advanced-menus-core/static-1.15086",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12031",
  "ExportDialog": "/ExportDialog/static-6.10366",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33963",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3775",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4120",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3987",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6761",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3568",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3669",
  "persist-promise": "/persist-promise/static-1.3672",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5357",
  "reactive-lib": "/reactive-lib/static-1.696",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.310",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2987",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.146",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.263",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3705",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15085",
  "simple-menus-lib": "/simple-menus-lib/static-1.16602",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3586",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9161",
  "react-flip-move": "/react-flip-move/static-1.69"
}
};
